import { yup } from 'src/common/infra/validations';

export const genericAnalyticsFilterSchema = yup.object().shape({
    operation: yup.string(),
});
